import { ReactNode, useMemo } from 'react';
// @mui
import { alpha, createTheme, ThemeProvider, useTheme } from '@mui/material/styles';
// hooks
import useSettings from '../../hooks/useSettings';
//
import { ClubWebPortal } from 'src/graphql/generated';
import componentsOverride from '../../theme/overrides';

// ----------------------------------------------------------------------

type Props = {
  clubWebPortal: ClubWebPortal;
  children: ReactNode;
};

export default function ClubTheme({ children, clubWebPortal }: Props) {
  const defaultTheme = useTheme();

  const { setColor } = useSettings();

  const themeOptions = useMemo(
    () => ({
      ...defaultTheme,
      palette: {
        ...defaultTheme.palette,
        primary: {
          ...setColor,
          main: clubWebPortal.buttonBackgroundColor || setColor.main,
          dark: alpha(clubWebPortal.buttonBackgroundColor || setColor.main, 0.9),
        },
      },
      customShadows: {
        ...defaultTheme.customShadows,
        primary: `0 8px 16px 0 ${alpha(
          clubWebPortal.buttonBackgroundColor || setColor.main,
          0.24
        )}`,
      },
    }),
    [defaultTheme, setColor, clubWebPortal]
  );

  const theme = createTheme(themeOptions);

  theme.components = componentsOverride(theme);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
